import Vue from 'vue'
import VueI18n from 'vue-i18n'

Vue.use(VueI18n)

export const i18n = new VueI18n({
    locale: 'en',
    fallbackLocale: 'es',
    messages:{
        en: {
            barranavegacion: ["Service", "Telescopes", "Location", "Gallery", "Pricing", "Moonphase discount", "Contact", "Our Partners"],
            tituloprincipal:["Explore The Universe", "With out automated remote telescopes", "from the Elqui Valley"],
            separador:["OUR SERVICES", "OUR TELESCOPES", "LOCATION", "PRICING", "MOONPHASE DISCOUNT", "CONTACT", "OUR PARTNERS"],
            servicios:[
                {
                    titulo: "Astronomy Camp",
                    descripcion: "We offer a spectacular camp where you will live a true astronomical experience under the best sky in the world. Do you want to know the surprises we have for you? just click here"
                },
                {
                    titulo: "Interactive Individual Session",
                    descripcion: "From home or wherever you want, rent a telescope and take the control just with your browser. Capture the universe under the best sky in the world. Online guidance is available as you want."
                },
                {
                    titulo: "Interactive Group Session",
                    descripcion: "With your friends, fellows or student. Rent a telescope in a group session and take control just through the browser. Capture the universe and share the moment with the best company. Online guidance is available as you want."
                }
            ],
            titulotelescopios: ["THE BEST TELESCOPES AVAILABLE FOR YOU", "Two powerful fully automated dome-telescopes equipped with high-end CCD cameras for immortalizing the universe with the highest quality you can find in Chile."],
            descripciontelescopio: ["The PlaneWave Instruments CDK20 is a 20 inch (0.51 m) f/6.8 Corrected Dall-Kirkham Astrograph telescope. The CDK20 has a dual carbon-fiber truss design, with 3 cooling fans ejecting air from the back of the telescope. The CDK20 covers a 52 mm field of view without any field curvature, off-axis coma, or astigmatism. The instrument weight is 140 lbs (64 kg) and comes standard with a back plate retaining ring ready to accept the focuser of your choice.",
                                    "REGINATO T700 Newton reflector is a 28 inches (71 cm) f/3.1 telescope. This unit covers 40mm FOV and counts with a 3″ rotatory focuser. It has been built by the Italian factory Reginato Telescopes, customized under the EVAscopes observatory requirements. Specifically deep space object like nebulas and galaxies. We are proud to say it’s a unique piece in the world!"],
            especificacionestenicas: ["TECHNICAL SPECS"],
            localidades:[
                {
                    titulo: "THE BEST!",
                    descripcion: "We share the sky with the international scientific observatories: Tololo, Gemini and SOAR, with about 300 clear nights a year.",
                },
                {
                    titulo: "Certified Skies",
                    descripcion: "The International Dark-Sky Association declared Elqui valley the world’s first International Dark Sky Sanctuary in 2015 due to the unrivalled purity of its skies.",
                },
                {
                    titulo: "Incomparable",
                    descripcion: "The Elqui Valley is one of the few places where you can see up to the eighth magnitude with the naked eye and whose geographical position is such that you can see the center of the galaxy with ease.",
                }
            ],
            contacto:["CONTACT US", "Are you an Entity?", 
            [
                "Natural Person", "Educational Institution", "Company", "StartUp", "NonProfit Organization"
            ], "Name", "E-mail", "Country", "Subject", "Message", "Send", "Clear"],
            aboutus:[
                "About Us", 
                "EVAscopes is a company dedicated to remote astrophotography that has two fully automated telescopes and under the best sky in Chile and the world.",
                "Follow Us",
                "Useful Links",
                "Help",
                "Contact Us"
            ],
            login:[
                "Enter your Email Evascopes",
                "Please Enter your password",
                "Loading system",
                "Please wait a minute...",
                "Close",
                "Back",
                "Next",
                "Loading..."
            ],
            clickimagen: ["Click to view"]
        },
        es:{
            barranavegacion: ["Servicios", "Telescopios", "Location", "Galeria", "Precios", "Descuento Fase Lunar", "Contacto", "Nuestros Partners"],
            tituloprincipal:["Explora El Universo", "con nuestros telescopios remotos automatizados", "del Valle del Elqui"],
            separador:["NUESTROS SERVICIOS", "NUESTROS TELESCOPIOS", "LOCALIDAD", "PRECIOS", "DESCUENTO FASE LUNAR", "CONTACTO", "NUESTROS PARTNERS"],
            servicios:[
                {
                    titulo: "Campamento Astronómico",
                    descripcion: "Te ofrecemos un espectacular campamento donde vivirás una verdadera experiencia astronómica bajo los mejores cielos del mundo.¿Quieres saber de las sorpresas que tenemos para ti? Solo haz click aquí"
                },
                {
                    titulo: "Sesión Interactiva Individual",
                    descripcion: "Desde tu hogar o donde tu quieras, arrienda un telescopio y toma el control de él simplemente desde un navegador web. Captura el universo bajo los mejores cielos del mundo. Nuestro guia online esta accesible para ti cuando tu lo necesites"
                },
                {
                    titulo: "Sesión Interactiva Grupal",
                    descripcion: "Con tus amigos, becarios o estudiantes. Arrienda un telescopio en una sesión grupal y toma control simplemente desde un navegador web. Captura el universo y comparte ese momento con tu mejor compañia. Nuestro guia online esta accesible para ti cuando tu lo necesites"
                }
            ],
            titulotelescopios:["LOS MEJORES TELESCOPIOS ACCESIBLES PARA TI", "Dos poderosos y completamente automatizados telescopios domoticos equipados con alto acabado fotografico gracias a su CCD camara para inmortalizar el universo con la mas alta calidad que puedas encontrar en chile"],
            descripciontelescopio:["El Planewave CDK20 es un telescopio de astrofotografía Dall-Kirkham corregido. Tiene un diseño de doble fibra de carbono, con 3 ventiladores de enfriamiento que expulsan aire desde la parte posterior del telescopio. Cubre un campo de visión de 52 mm sin ninguna curvatura de campo, vision fuera del eje o astigmatismo. Su peso es de 140 lb (64kg) y viene con un anillo de retención de la placa posterior listo para aceptar el enfocador que se elija",
                                    "El Reginato T700 Newton es una telescopio f/3.1 de 28 pulgadas (71cm). Esta unidad cubre un FOV de 40 cm y cuenta con un enfocador rotativo de 3 pulgadas. Fue construido por la fábrica italiana Reginato Telescopes, personalizado bajo los requerimientos del observatorio Evascopes; Especificamente objetos del espacio profundo como nebulosas y galaxias. ¡Estamos orgullosos de decir que es una pieza unica en el mundo!"],
            especificacionestenicas: ["ESPECIFICACIONES TÉCNICAS"],
            localidades:[
                {
                    titulo: "EL MEJOR!",
                    descripcion: "Nosotros compartimos el cielo con los observatorios científicos internacionales: Tololo, Gemeni y SOAR. Con al rededor de 300 noches limpias al año",
                },
                {
                    titulo: "Cielos Certificados",
                    descripcion: "La International Dark-Sky Association declaró al Valle del Elqui como primer International Dark Sky Sanctuary en el 2015 debido a la pureza inigualable de sus cielos",
                },
                {
                    titulo: "Incomparable",
                    descripcion: "El Valle del Elqui es uno de los pocos lugares donde puedes ver hasta la octava magnitud a simple vista y cuya posición geográfica estal que se puede ver el centro de la galaxia con facilidad",
                }
            ],
            contacto:["CONTACTANOS", "¿Eres una entidad?", [
                "Persona Natural", "Institucion Educativa", "Compañia", "StartUp", "Organizacion sin fines de lucro"
            ], "Nombre", "E-mail", "Pais", "Asunto", "Mensaje", "Enviar", "Limpiar"],
            aboutus:[
                "Acerca de nosotros", 
                "Evascopes es una compañia dedicada a la astrofotografia remota que cuenta con dos telescopios completamente automatizados y bajo los mejores cielos de chile y del mundo", 
                "Siguenos",
                "Link Utiles",
                "Ayuda",
                "Contactanos"
            ],
            login:[
                "Ingresa tu Email Evascopes",
                "Por favor ingresa tu password",
                "Cargando sistema...",
                "Por favor espere un minuto...",
                "Cerrar",
                "Volver",
                "Siguiente",
                "Cargando..."
            ],
            clickimagen: ["Click para Ver"]
        }
    }
})